import { isHTMLElement } from '../../typeValidators';
import alphaBlendColors from './alphaBlendColors';
import getRgbaFromColor from './getRgbaFromColor';

/*
  Walks up the DOM from the given element, collecting background colors, then composites them from root
  down to produce the effective background color.
  Returns undefined if any ancestor has a background-image or a background-color we can't parse
  (e.g. lab(), oklab(), oklch()) — the caller should fall back to a heuristic in these cases.
*/
export default function getEffectiveBackgroundColorRgb(
  element: Element | null,
): [number, number, number] | undefined {
  if (!element) {
    return;
  }

  const layers: [number, number, number, number][] = [];
  let current: Element | null = element;

  while (current) {
    if (!isHTMLElement(current)) {
      current = current.parentElement;
      continue;
    }

    const style = window.getComputedStyle(current);

    const backgroundImage = style.getPropertyValue('background-image').trim();
    if (backgroundImage !== 'none' && backgroundImage !== '') {
      return;
    }

    const backgroundColor = style.getPropertyValue('background-color').trim();
    if (backgroundColor && backgroundColor !== 'transparent' && backgroundColor !== 'rgba(0, 0, 0, 0)') {
      const rgba = getRgbaFromColor(backgroundColor);
      if (!rgba) {
        return;
      }
      if (rgba[3] > 0) {
        layers.push(rgba);
      }
    }

    current = current.parentElement;
  }

  let result: [number, number, number] = [255, 255, 255];

  for (let i = layers.length - 1; i >= 0; i--) {
    result = alphaBlendColors(layers[i], result);
  }

  return result;
}
